import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Gift, X } from "@phosphor-icons/react";

const STORAGE_KEY = "ji_refer_chip_dismissed_v1";

/**
 * A small, dismissible floating chip that promotes the Refer & Earn program.
 * Appears bottom-right on desktop, bottom-center on mobile.
 * Hidden if the visitor dismissed it in this browser.
 */
export default function ReferChip() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Wait a moment before showing so it doesn't clash with hero load.
    const dismissed = typeof window !== "undefined" && window.localStorage.getItem(STORAGE_KEY);
    if (dismissed) return;
    const t = setTimeout(() => setVisible(true), 1500);
    return () => clearTimeout(t);
  }, []);

  const dismiss = (e) => {
    e.preventDefault();
    e.stopPropagation();
    try { window.localStorage.setItem(STORAGE_KEY, "1"); } catch { /* ignore */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Link
      to="/refer"
      data-testid="refer-chip"
      className="fixed z-40 bottom-5 right-5 md:right-6 md:bottom-6 group flex items-center gap-3 pl-4 pr-2 h-12 bg-[var(--ji-accent)] text-white shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5"
      style={{
        borderRadius: 999,
        animation: "ji-chip-pop 0.45s cubic-bezier(0.22, 1, 0.36, 1)",
      }}
    >
      <span className="relative inline-flex items-center justify-center w-7 h-7 bg-white/20 rounded-full">
        <Gift size={16} weight="fill" />
        <span className="absolute inset-0 rounded-full animate-ping bg-white/30" style={{ animationDuration: "2.4s" }} />
      </span>
      <span className="text-sm font-semibold pr-1 whitespace-nowrap" style={{ fontFamily: "Cabinet Grotesk" }}>
        Refer &amp; Earn <span className="opacity-90">— $25 off</span>
      </span>
      <button
        type="button"
        onClick={dismiss}
        data-testid="refer-chip-dismiss"
        aria-label="Dismiss"
        className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-white/10 hover:bg-white/30 transition-colors flex-shrink-0"
      >
        <X size={12} weight="bold" />
      </button>
      <style>{`
        @keyframes ji-chip-pop {
          0% { transform: translateY(20px) scale(0.85); opacity: 0; }
          100% { transform: translateY(0) scale(1); opacity: 1; }
        }
      `}</style>
    </Link>
  );
}
